export function getRDG(userDoc: string): number | string | null {
  const userRdg = !!userDoc ? Number(userDoc.slice(5,7)) : '';
  return userRdg;
}
